import type { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import { Icon } from '../../../shared/components/icon/icon';
import { createStyleHelper, createClassName } from '../../../shared/utils/class-names';

import styles from './requirements-info.module.scss';

const style = createStyleHelper(styles, 'requirements-info');

export interface IRequirementsInfoProps {
    className?: string;
}

export const RequirementsInfo: FunctionComponent<IRequirementsInfoProps> = ({ className }) => {
    return (
        <div className={createClassName([style(), className])}>
            <div className={style('title-section')}>
                <FormattedMessage
                    id={'account.verification.instructions.requirements-title'}
                    defaultMessage={'What are the requirements to upload your documents?'}
                />
            </div>
            <div className={style('requirement')}>
                <Icon name={'circle'} className={style('requirement-icon')} />
                <FormattedMessage
                    id={'account.verification.instructions.file-max-size'}
                    defaultMessage={'Files must be a maximum size of 10MB.'}
                />
            </div>
            <div className={style('requirement')}>
                <Icon name={'circle'} className={style('requirement-icon')} />
                <FormattedMessage
                    id={'account.verification.instructions.file-supported-types'}
                    defaultMessage={
                        'Supported file types include the following formats: PNG, PDF or JPEG.'
                    }
                />
            </div>
            <div className={style('requirement')}>
                <Icon name={'circle'} className={style('requirement-icon')} />
                <FormattedMessage
                    id={'account.verification.instructions.provide-front-and-back'}
                    defaultMessage={
                        'Remember to provide front and back of Proof of ID or Driver License. Make sure the document is clearly visible.'
                    }
                />
            </div>
        </div>
    );
};
